import type { ComponentPropsWithRef } from 'react';
import { cn } from '@ifixit/ui/lib/utils';
import { useTrackedOnClick } from '@ifixit/tracking-hooks';

export function FooterLegalSection({
   ref,
   children,
   className,
   ...otherProps
}: ComponentPropsWithRef<'div'>) {
   return (
      <div
         ref={ref}
         className={cn(
            'mt-6 flex flex-col-reverse items-center justify-center gap-5 px-5 text-gray-400 sm:px-0 md:flex-row md:gap-0',
            className
         )}
         {...otherProps}
      >
         {children}
      </div>
   );
}

export function FooterCopyright({
   ref,
   copyrightName,
   locale,
   className,
   ...props
}: Omit<ComponentPropsWithRef<'div'>, 'children'> & {
   copyrightName: string;
   locale: string;
}) {
   const currentYear = new Date().toLocaleDateString(locale, { year: 'numeric' });

   return (
      <div ref={ref} className={cn('text-sm', className)} {...props}>
         &copy; {currentYear} {copyrightName}
      </div>
   );
}

export function FooterLegalLinkList({
   ref,
   children,
   className,
   ...otherProps
}: ComponentPropsWithRef<'div'>) {
   return (
      <div
         ref={ref}
         className={cn('flex flex-col gap-1.5 text-sm md:flex-row md:gap-0', className)}
         {...otherProps}
      >
         <div className="hidden px-1 md:block">—</div>
         {children}
      </div>
   );
}

export function FooterLegalLink({ ref, className, ...props }: ComponentPropsWithRef<'a'>) {
   const trackedOnClick = useTrackedOnClick(props);
   return (
      <a
         ref={ref}
         onClick={trackedOnClick}
         className={cn(
            "text-gray-400 transition-colors duration-300 hover:text-gray-100 hover:no-underline md:not-first-of-type:before:px-1 md:not-first-of-type:before:text-gray-400 md:not-first-of-type:before:content-['-']",
            className
         )}
         {...props}
      />
   );
}
